import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fieldTranslate',
  standalone: true
})
export class FieldTranslatePipe implements PipeTransform {

  transform(value: string, selectionList: any): string {
    if (!value || !selectionList || !Array.isArray(selectionList)) {
      return value;
    }

    const values = String(value).split(',').map(val => val.trim());
    const translatedValues = values.map(val => {
      const item = selectionList.find((obj: any) => obj.value === val);
      return item ? item.title : val;
    });

    return translatedValues.join(', ');
  }

}
